// Reactive job drafts composable — shared across App.vue, DashboardPage, JobFormPage.
import { ref } from 'vue';
import {
  addJobDraft as _addJobDraft,
  loadJobDrafts as _loadJobDrafts,
  removeJobDraft as _removeJobDraft,
  updateJobDraft as _updateJobDraft,
  type JobDraft,
} from './utils';

const drafts = ref<JobDraft[]>(_loadJobDrafts());

/** Decorate local drafts as temporary job rows for web-only calendar views. */
export function getDraftJobsForCalendar(source: JobDraft[]): Record<string, any>[] {
  return source.map((draft) => ({
    ...draft.job,
    // Keep drafts distinct from saved jobs and Google Calendar JobIDs.
    JobID: `draft:${draft.id}`,
    _draftId: draft.id,
    _isDraft: true,
  }));
}

export function useJobDrafts() {
  function refresh() {
    drafts.value = _loadJobDrafts();
  }
  function add(job: Record<string, any>): JobDraft {
    const draft = _addJobDraft(job);
    refresh();
    return draft;
  }
  function update(id: string, job: Record<string, any>): JobDraft | null {
    const draft = _updateJobDraft(id, job);
    refresh();
    return draft;
  }
  function remove(id: string) {
    _removeJobDraft(id);
    refresh();
  }
  return { drafts, add, update, remove, refresh };
}
